export const DropWidgetsHereMessage = () => "Drop Widgets Here";
export const DropModalHereMessage = () => "Drop the Modal here";
export const ANVIL_WIDGET_NAME_TOGGLE_PARENT = () => "Select parent widget";
export const ANVIL_WIDGET_NAME_DEBUG_CLICK = () => "Debug issue";
